module.exports = __webpack_public_path__ + "static/media/selena-gomez-icon.f7c6aad6.jpg";